import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  PublicEventDetailsResponse,
  PublicExhibitionItem,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { styles as rootStyle } from './../../styles';
import { useTranslation } from 'react-i18next';
import { getImageSrc } from '@utils/fn';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface PartnerThisYearPageProps {
  event: PublicEventDetailsResponse;
  exhibitions: PublicExhibitionItem[];
  footer: JSX.Element;
}

const ITEMS_PER_ROW = 8;
const MAX_ROWS = 6;
const ITEMS_PER_PAGE = ITEMS_PER_ROW * MAX_ROWS;

const PartnerThisYearPage = ({
  event,
  exhibitions,
  footer,
}: PartnerThisYearPageProps) => {
  const { t } = useTranslation();

  const exhibitionsList =
    exhibitions?.filter(
      (attendee: PublicExhibitionItem) => attendee?.company?.logo
    ) || [];

  const pages: PublicExhibitionItem[][] = [];
  for (let i = 0; i < exhibitionsList.length; i += ITEMS_PER_PAGE) {
    pages.push(exhibitionsList.slice(i, i + ITEMS_PER_PAGE));
  }

  return (
    <>
      {pages.map((pageItems, pageIndex) => (
        <Page
          key={pageIndex}
          size={{ width: 1440, height: 800 }}
          style={styles.page}
        >
          <View style={styles.fullWidthContainer}>
            {pageIndex === 0 && (
              <>
                <Text style={styles.pageTitle}>
                  {t('our-business-partner')?.toUpperCase()}
                </Text>

                <View
                  style={{
                    ...globalStyles.lineBar,
                    alignSelf: 'center',
                    borderColor: event?.design?.themeColor ?? 'black',
                    marginTop: 20,
                    marginBottom: 40,
                    width: 200,
                  }}
                />
              </>
            )}

            <View style={styles.galleryContainer}>
              {pageItems.map((item, index) => {
                const logoSrc = getImageSrc(item?.company?.logo);

                return (
                  logoSrc && (
                    <View key={index} style={{ position: 'relative' }}>
                      <View
                        style={{
                          position: 'absolute',
                          top: 4,
                          left: 4,
                          width: 146,
                          height: 74,
                          backgroundColor: '#000',
                          opacity: 0.1,
                          borderRadius: 8,
                        }}
                      />
                      <View style={styles.logoWrapper}>
                        <SafeImage style={styles.logoImage} src={logoSrc} />
                      </View>
                    </View>
                  )
                );
              })}
            </View>
          </View>

          {/* ✅ Footer on every page */}
          <View style={rootStyle.footer}>{footer}</View>
        </Page>
      ))}
    </>
  );
};

export default PartnerThisYearPage;
